/**
 * AP-8 — Einhängepunkt der Views B. Lazy: ein Fenster wird erst beim ersten
 * `view:opened` gebaut, danach nur noch gezeigt (wie die Fenster im Original,
 * die einmal erzeugt und danach nur ein-/ausgeblendet werden).
 */

import { createAddressClaimView } from './AddressClaim';
import { createDm1View } from './Dm1';
import { createNodeScanView } from './NodeScan';
import type { CanConnection } from '../app/connection';
import type { AppStore } from '../app/store';

interface LazyView {
  show(): void;
}

export function mountViewsB(store: AppStore, connection: CanConnection): void {
  let dm1: LazyView | null = null;
  let addressClaim: LazyView | null = null;
  let nodeScan: LazyView | null = null;

  store.on('view:opened', (event) => {
    switch (event.kind) {
      case 'dm1':
        dm1 ??= createDm1View(store, connection);
        dm1.show();
        return;
      case 'address-claim':
        addressClaim ??= createAddressClaimView(store, connection);
        addressClaim.show();
        return;
      case 'node-scan':
        nodeScan ??= createNodeScanView(store, connection);
        nodeScan.show();
        return;
      default:
        return; // andere Views gehoeren AP-7/AP-9/AP-10/AP-11
    }
  });
}
